import Swal from 'sweetalert2';
import { isString } from 'lodash';

export default function sendForm() {
    const selectforms = document.querySelectorAll('[data-formvalidate]');
    
    if (selectforms.length) {
        selectforms.forEach((form, index) => {
            const message = form.dataset.message;
            
            // Configurar validação customizada
            setupFormValidation(form, message);
        });
    }

    // Substituir SVGs
    replaceSVGImages();
}

function setupFormValidation(form, showMessage) {
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        // Limpar erros anteriores
        clearErrors(form);
        
        // Validar campos
        const requiredFields = form.querySelectorAll('.required.error');
        // Valida se o check de privacidade está marcado
        const checkTerm = form.querySelector('#checkTerm');

        // Verifica se todos os campos obrigatórios estão corretos e se o termo está marcado (se existir)
        const isCheckTermValid = !checkTerm || (checkTerm && checkTerm.checked);

        if (requiredFields.length === 0 && isCheckTermValid) {
            form.removeAttribute('disabled');

            submitForm(form);
        }
    });
}

function showFieldError(field, message) {
    // Remover erro anterior se existir
    const existingError = field.parentNode.querySelector('.error-message');
    if (existingError) {
        existingError.remove();
    }
    
    // Criar elemento de erro
    const errorElement = document.createElement('label');
    errorElement.className = 'error-message';
    errorElement.textContent = message;
    errorElement.style.color = 'red';
    errorElement.style.fontSize = '12px';
    errorElement.style.display = 'block';
    
    // Inserir após o campo
    field.parentNode.insertBefore(errorElement, field.nextSibling);
}

function clearErrors(form) {
    const errorMessages = form.querySelectorAll('.error-message');
    errorMessages.forEach(error => error.remove());
}

function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function submitForm(form) {
    const loader = document.getElementById('loader_form');
    if (loader) {
        loader.style.display = 'block';
    }
    
    let data;
    let contentType = "application/x-www-form-urlencoded";
    let processData = true;
    
    // Verificar se é multipart/form-data
    if (form.getAttribute('enctype') === 'multipart/form-data') {
        const formData = new FormData();
        
        // Adicionar campos de texto
        const formElements = new FormData(form);
        for (let [key, value] of formElements.entries()) {
            if (typeof value === 'string' && !value) {
                value = '';
            }
            formData.append(key, value);
        }
        
        // Adicionar arquivos
        const fileInputs = form.querySelectorAll('.form-file');
        fileInputs.forEach(fileInput => {
            try {
                if (fileInput.files[0]) {
                    formData.append(fileInput.name, fileInput.files[0]);
                }
            } catch (error) {
                console.error('Erro ao adicionar arquivo:', error);
            }
        });
        
        data = formData;
        contentType = false;
        processData = false;
    } else {
        data = new URLSearchParams(new FormData(form)).toString();
    }
    
    // Verificar se grecaptcha está disponível
    if (typeof grecaptcha !== 'undefined') {
        grecaptcha.ready(function() {
            const recaptchaElement = document.getElementById('recaptcha');
            const siteKey = recaptchaElement ? recaptchaElement.value : '';
            
            grecaptcha.execute(siteKey, {
                action: 'submit'
            }).then(function(token) {
                if (isString(data)) {
                    data = data + '&gRecaptchaResponse=' + token;
                } else {
                    data.append('gRecaptchaResponse', token);
                }
                
                sendAjaxRequest(form, data, contentType, processData);
            });
        });
    } else {
        sendAjaxRequest(form, data, contentType, processData);
    }
}

function sendAjaxRequest(form, data, contentType, processData) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]');
    const headers = {
        'X-CSRF-Token': csrfToken ? csrfToken.getAttribute('content') : ''
    };
    
    // Adicionar Content-Type apenas se não for FormData
    if (contentType !== false) {
        headers['Content-Type'] = contentType;
    }
    
    fetch(form.getAttribute('action'), {
        method: form.getAttribute('method') || 'POST',
        headers: headers,
        body: data
    })
    .then(response => {
        const loader = document.getElementById('loader_form');
        if (loader) {
            loader.style.display = 'none';
        }
        
        return response.text();
    })
    .then(responseText => {
        try {
            const data = JSON.parse(responseText);
            
            Swal.fire({
                icon: data.status,
                title: data.status === "success" ? "Muito Obrigado!" : "Ops!",
                text: data.message
            });
            
            if (data.redirect) {
                window.location = data.redirect;
            }
        } catch (error) {
            console.error('Erro ao parsear resposta:', error);
            showErrorAlert();
        }
    })
    .catch(error => {
        const loader = document.getElementById('loader_form');
        if (loader) {
            loader.style.display = 'none';
        }
        
        console.error('Erro na requisição:', error);
        showErrorAlert();
    });
}

function showErrorAlert() {
    Swal.fire({
        icon: 'warning',
        title: "Oops, algo deu errado!",
        text: "Não foi possível enviar sua mensagem."
    });
}

/**
 * Substituir todas as imagens SVG por SVG inline
 */
function replaceSVGImages() {
    const svgImages = document.querySelectorAll('img.svg');
    
    svgImages.forEach(img => {
        const imgID = img.getAttribute('id');
        const imgClass = img.getAttribute('class');
        const imgURL = img.getAttribute('src');
        
        fetch(imgURL)
            .then(response => response.text())
            .then(data => {
                // Criar um parser para o XML
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(data, 'image/svg+xml');
                const svg = xmlDoc.querySelector('svg');
                
                if (svg) {
                    // Adicionar ID da imagem substituída ao novo SVG
                    if (imgID) {
                        svg.setAttribute('id', imgID);
                    }
                    
                    // Adicionar classes da imagem substituída ao novo SVG
                    if (imgClass) {
                        svg.setAttribute('class', imgClass + ' replaced-svg');
                    }
                    
                    // Remover atributos XML inválidos
                    svg.removeAttribute('xmlns:a');
                    
                    // Substituir imagem pelo novo SVG
                    img.parentNode.replaceChild(svg, img);
                }
            })
            .catch(error => {
                console.error('Erro ao carregar SVG:', error);
            });
    });
}

document.querySelectorAll('[phone]').forEach(phoneElement => {
    phoneElement.addEventListener('keypress', function (event) {
        const charCode = event.which || event.keyCode;

        if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode) || (charCode === 190 && !this.value.includes('.'))) {
            return;
        }

        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    });

    phoneElement.addEventListener('blur', function () {
        mascaraDeTelefone(this);
    });

    phoneElement.addEventListener('focus', function () {
        tiraHifen(this);
    });
});

function mascaraDeTelefone(telefone) {
    const textoAtual = telefone.value.replace(/[^0-9]/g, '');
    const isCelular = textoAtual.length >= 11;
    let textoAjustado;

    if (isCelular) {
        const parte1 = textoAtual.slice(0, 2);
        const parte2 = textoAtual.slice(2, 7);
        const parte3 = textoAtual.slice(7, 11);

        textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
    } else {
        const parte1 = textoAtual.slice(0, 2);
        const parte2 = textoAtual.slice(2, 6);
        const parte3 = textoAtual.slice(6, 10);

        textoAjustado = `(${parte1}) ${parte2}${parte3 ? '.' + parte3 : ''}`;
    }

    telefone.value = textoAjustado || null;
}

function tiraHifen(telefone) {
    telefone.value = telefone.value.replace(/\./g, '');
}

document.querySelectorAll('[only-numbers]').forEach(numberElement => {
    numberElement.addEventListener('keypress', function (event) {
        const charCode = event.which || event.keyCode;

        // Permitir: Backspace, Delete, Tab, Esc, Enter, Home, End, Setas
        if ([8, 46, 9, 27, 13, 35, 36, 37, 39].includes(charCode)) {
            return;
        }

        // Bloquear se não for número (0 a 9)
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    });

    numberElement.addEventListener('input', function () {
        // Remove qualquer caractere não numérico (caso o usuário cole algo errado)
        this.value = this.value.replace(/\D/g, '');
    });
});
